/// TYPES ///
import { Counter } from "api/types/sketch";
import { DiagramProps } from "api/types/sketch";
import { Label } from "api/types/sketch";
/// PDF COMPONENTS ///
import { Canvas } from "@react-pdf/renderer";
/// STYLES ///
import { drawPrintPreviewCounter } from "functions/sketch";
import { drawPrintOrderSink } from "functions/sketch";
import { drawPrintOrderCooktop } from "functions/sketch";
/// VALUES ///
import { getDiagramProps } from "functions/sketch/get/diagram";

interface Props {
  counters: Counter[],
  labels: Label[],
}

export default function QuotePrintCounters({ counters, labels }: Props) {
  const paintCanvas = (painter: any, availableWidth: number, availableHeight: number) => {
    const props: DiagramProps = getDiagramProps(counters, { X: Math.round(availableWidth), Y: availableHeight });

    painter.fontSize(7.5);

    for (let i = 0; i < counters.length; i++) {
      drawPrintPreviewCounter(
        counters[i].corners,
        counters[i].points,
        painter,
        props.offset,
        props.zoom
      );

      drawPrintOrderCooktop(painter, counters[i], props.offset, props.zoom);
      drawPrintOrderSink(painter, counters[i], props.offset, props.zoom);
    }

    for(let i = 0; i < labels.length; i++){
        painter.fontSize(labels[i].size);

	let height_adjustment = 0;

	if(labels[i].size === 18){
	   height_adjustment = 7;
	}
	else if(labels[i].size === 16){
	   height_adjustment = 5;
	}
	else if(labels[i].size === 14){
	   height_adjustment = 3;
	}
	else if(labels[i].size === 12){
	   height_adjustment = 1;
	}

        painter.text(
          labels[i].text,
          (labels[i].location.X * props.zoom) + props.offset.X - 5 - 2 * labels[i].text.length,
          (labels[i].location.Y * props.zoom) + props.offset.Y - 8 - height_adjustment
	);
    }

    painter.stroke("#666666");
    return null;
  }
  return (
    <Canvas
      style={{ height: "100%", width: "100%" }}
      paint={paintCanvas} />
  );
}
